var _path, _path2, _g, _path3, _path4, _g2, _path5, _path6, _g3, _path7, _path8, _g4, _path9, _path10, _g5, _path11, _path12, _path13, _g6, _path14, _path15, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCellphone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 420,
    height: 419
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 0H459.417V418.833H40.5833V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 0,
    width: 420,
    height: 419
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M250 0C134.344 0 40.5833 93.7604 40.5833 209.417C40.5833 325.073 134.344 418.833 250 418.833C365.656 418.833 459.417 325.073 459.417 209.417C459.417 93.7604 365.656 0 250 0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.5833 0H459.417V418.833H40.5833V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105.5 360.438H394.667V500H105.5V360.438Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 105,
    y: 360,
    width: 290,
    height: 140
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M250 500L394.5 360.438H105.5L250 500Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.5 360.438H394.438V500H105.5V360.438Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 400,
    height: 400
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3438 11.651H449.656V410.964H50.3438V11.651Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 50,
    y: 11,
    width: 400,
    height: 400
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M250 11.651C139.734 11.651 50.3438 101.042 50.3438 211.307C50.3438 321.573 139.734 410.964 250 410.964C360.266 410.964 449.656 321.573 449.656 211.307C449.656 101.042 360.266 11.651 250 11.651Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3438 11.651H449.656V410.964H50.3438V11.651Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 276,
    height: 134
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.234 355.292H388V488.349H112.234V355.292Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 355,
    width: 276,
    height: 134
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M250 488.349L387.766 355.292H112.234L250 488.349Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.234 355.292H387.708V488.349H112.234V355.292Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 372,
    height: 371
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 26.0104H435.297V396.604H64.7031V26.0104Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask9_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 26,
    width: 372,
    height: 371
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M250 26.0104C147.661 26.0104 64.7031 108.969 64.7031 211.307C64.7031 313.646 147.661 396.604 250 396.604C352.339 396.604 435.297 313.646 435.297 211.307C435.297 108.969 352.339 26.0104 250 26.0104Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.7031 26.0104H435.297V396.604H64.7031V26.0104Z",
    fill: "white"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M306.25 87.25H193.75C181.375 87.25 171.362 97.375 171.362 109.75V312.25C171.362 324.625 181.375 334.75 193.75 334.75H306.25C318.625 334.75 328.75 324.625 328.75 312.25V109.75C328.75 97.375 318.625 87.25 306.25 87.25ZM306.25 278.5H193.75V143.5H306.25V278.5Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 166,
    width: 28,
    height: 67
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M236 166H263.403V232.073H236V166Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask11_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 236,
    y: 166,
    width: 28,
    height: 66
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M253.611 228.768L263.112 182.437C263.938 178.409 262.909 174.223 260.308 171.037C257.709 167.85 253.814 166 249.701 166C245.589 166 241.694 167.85 239.095 171.037C236.494 174.223 235.465 178.409 236.291 182.437L245.791 228.768C246.171 230.625 247.806 231.958 249.701 231.958C251.596 231.958 253.232 230.625 253.611 228.768Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M232.922 166H266.481V247.804H232.922V166Z",
    fill: "black"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 239,
    width: 18,
    height: 18
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M241.038 239.179H258.364V256.503H241.038V239.179Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_2011_2)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_2011_2",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 241,
    y: 239,
    width: 18,
    height: 18
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M249.701 239.179C244.916 239.179 241.038 243.057 241.038 247.842C241.038 252.625 244.916 256.503 249.701 256.503C254.486 256.503 258.364 252.625 258.364 247.842C258.364 243.057 254.486 239.179 249.701 239.179Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_2011_2)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M241.038 239.179H258.364V256.503H241.038V239.179Z",
    fill: "black"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCellphone);
export default __webpack_public_path__ + "static/media/cellphone.87ff5b5251b17f295441cd9d08e281ce.svg";
export { ForwardRef as ReactComponent };